(() => {
  const translations = {
    cs: { heading: 'Aktuální ceník dopravy', country: 'Doručení do země: ', intro: 'Rozbalte dopravce pro ceny, dobírku a podmínky dopravy zdarma.', loading: 'Načítáme aktuální ceny dopravy…', error: 'Ceník se nyní nepodařilo načíst. Cenu dopravy uvidíte při dokončení objednávky.', empty: 'Pro tuto zemi nejsou v ceníku dostupné sazby dopravy.', retry: 'Zkusit znovu', free: 'Zdarma', calculated: 'Cena při objednávce', from: 'od ', order: 'Hodnota objednávky ', weight: 'Hmotnost zásilky ', minimum: 'od ', maximum: 'do ', all: 'Bez omezení hodnoty a hmotnosti objednávky.', extra: 'Další podmínky ověříte při objednávce.', regions: 'Oblasti: ', updated: 'Ceník aktualizován: ', note: 'Ceny jsou uvedeny v měně nastavené u příslušné sazby. Konečná dostupnost a cena závisí na doručovací adrese, zboží a splnění všech uvedených podmínek.' },
    en: { heading: 'Current shipping prices', country: 'Delivery country: ', intro: 'Expand a carrier to view prices, cash on delivery and free shipping conditions.', loading: 'Loading current shipping prices…', error: 'Shipping prices could not be loaded. You will see shipping costs at checkout.', empty: 'No shipping rates are available for this country in the price list.', retry: 'Try again', free: 'Free', calculated: 'Price at checkout', from: 'from ', order: 'Order value ', weight: 'Shipment weight ', minimum: 'from ', maximum: 'up to ', all: 'No order value or weight restrictions.', extra: 'Check further conditions at checkout.', regions: 'Regions: ', updated: 'Prices updated: ', note: 'Prices use the currency configured for each rate. Final availability and cost depend on the delivery address, products and all conditions listed.' },
    de: { heading: 'Aktuelle Versandpreise', country: 'Lieferland: ', intro: 'Öffnen Sie einen Versanddienst für Preise, Nachnahme und Bedingungen für kostenlosen Versand.', loading: 'Aktuelle Versandpreise werden geladen…', error: 'Die Versandpreise konnten nicht geladen werden. Die Versandkosten sehen Sie beim Checkout.', empty: 'Für dieses Land sind keine Versandtarife in der Preisliste verfügbar.', retry: 'Erneut versuchen', free: 'Kostenlos', calculated: 'Preis beim Checkout', from: 'ab ', order: 'Bestellwert ', weight: 'Sendungsgewicht ', minimum: 'ab ', maximum: 'bis ', all: 'Keine Einschränkung des Bestellwerts oder Gewichts.', extra: 'Weitere Bedingungen sehen Sie beim Checkout.', regions: 'Regionen: ', updated: 'Preise aktualisiert: ', note: 'Die Preise werden in der für den jeweiligen Tarif festgelegten Währung angezeigt. Verfügbarkeit und Endpreis hängen von Lieferadresse, Produkten und allen aufgeführten Bedingungen ab.' }
  };
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function carrier(name) {
    const normalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    for (const [pattern, label] of [[/balikovna/, 'Balíkovna'], [/\bdpd\b/, 'DPD'], [/\bgls\b/, 'GLS'], [/\bone\b/, 'ONE by Allegro'], [/\bppl\b/, 'PPL'], [/zasilkovna/, 'Zásilkovna'], [/packeta/, 'Packeta'], [/inpost/, 'InPost'], [/hermes/, 'Hermes PP']]) {
      if (pattern.test(normalized)) return label;
    }
    return name;
  }
  function localizeShipping(text, language) {
    if (!['de', 'en'].includes(language)) return text;
    const de = language === 'de';
    const phrases = [
      [/poskytnuto číslo pro sledování/gi, de ? 'Sendungsverfolgungsnummer verfügbar' : 'Tracking number provided'],
      [/výdejní místo/gi, de ? 'Abholstelle' : 'pickup point'],
      [/na adresu/gi, de ? 'Lieferung an die Adresse' : 'home delivery'],
      [/bez dobírky/gi, de ? 'ohne Nachnahme' : 'without cash on delivery'],
      [/dobírka/gi, de ? 'Nachnahme' : 'cash on delivery'],
      [/doprava zdarma/gi, de ? 'Kostenloser Versand' : 'Free shipping'],
      [/osobní odběr/gi, de ? 'Persönliche Abholung' : 'Local pickup'],
      [/výdejní box/gi, de ? 'Paketstation' : 'parcel locker']
    ];
    // Translate known shipping terms; preserve carrier brands and unfamiliar text.
    for (const [pattern, replacement] of phrases) text = text.replace(pattern, replacement);
    return text;
  }
  function roundShipping(amount, currency, enabled) {
    if (!enabled || amount <= 0) return amount;
    // Rules confirmed against this shop's EUR and PLN checkout.
    // Unknown currencies retain the indicative conversion.
    if (currency === 'EUR') return (Math.ceil(amount - 0.95 - 1e-9) * 100 + 95) / 100;
    if (currency === 'PLN') return Math.ceil(amount - 1e-9);
    return amount;
  }
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const locale = root.dataset.locale || 'cs';
    const language = locale.split('-')[0];
    const t = translations[language] || translations.cs;
    const translate = text => localizeShipping(text, language);
    let roundingEnabled = false;
    let converted = false;
    let conversionUnavailable = false;
    const content = root.querySelector('[data-shipping-content]');
    const heading = root.querySelector('[data-shipping-heading]');
    heading.textContent = t.heading;
    root.querySelector('[data-shipping-intro]').textContent = t.country + root.dataset.countryName + '. ' + t.intro;
    root.querySelector('[data-shipping-note]').textContent = t.note;
    // Place the widget in the existing shipping-price section when present.
    const page = root.closest('.page-width');
    const target = page?.querySelector('#cena-dopravy') || [...(page?.querySelectorAll('.rte h2') || [])].find(h => /cena dopravy|shipping (cost|price)|versandkosten/i.test(h.textContent));
    if (target && !root.contains(target)) target.after(root);
    function money(price, shipping = false) {
      let amount = Number(price.amount);
      let currency = price.currencyCode;
      const target = root.dataset.currency;
      const shopCurrency = root.dataset.shopCurrency;
      const settings = window.Shopify?.currency;
      const rate = Number(settings?.rate);
      if (target && currency !== target) {
        if (currency === shopCurrency && settings?.active === target && Number.isFinite(rate) && rate > 0) {
          amount *= rate;
          if (shipping) amount = roundShipping(amount, target, roundingEnabled);
          currency = target;
          converted = true;
        } else {
          conversionUnavailable = true;
        }
      }
      return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: Number.isInteger(amount) ? 0 : undefined }).format(amount);
    }
    function condition(c) {
      const value = c.value;
      const prefix = c.operator === 'GREATER_THAN_OR_EQUAL_TO' ? t.minimum : c.operator === 'LESS_THAN_OR_EQUAL_TO' ? t.maximum : null;
      if (!prefix) return t.extra;
      if (c.field === 'TOTAL_PRICE' && value?.__typename === 'MoneyV2') return t.order + prefix + money(value);
      if (c.field === 'TOTAL_WEIGHT' && value?.__typename === 'Weight') return t.weight + prefix + new Intl.NumberFormat(locale).format(value.value) + ' ' + ({ KILOGRAMS: 'kg', GRAMS: 'g', POUNDS: 'lb', OUNCES: 'oz' }[value.unit] || value.unit);
      return t.extra;
    }
    function rateRow(rate, regions) {
      const row = element('div', 'bh-shipping__row');
      row.append(element('div', 'bh-shipping__name', translate(rate.name)));
      const free = rate.price && Number(rate.price.amount) === 0;
      row.append(element('div', 'bh-shipping__price' + (free ? ' bh-shipping__free' : ''), free ? t.free : rate.price ? money(rate.price, true) : t.calculated));
      if (rate.description) row.append(element('div', 'bh-shipping__detail', translate(rate.description)));
      row.append(element('div', 'bh-shipping__detail', rate.conditions.length ? rate.conditions.map(condition).join(' · ') : rate.calculated ? t.calculated : t.all));
      if (regions.length) row.append(element('div', 'bh-shipping__detail', t.regions + regions.join(', ')));
      return row;
    }
    function render(data) {
      roundingEnabled = data.currencyRounding?.[root.dataset.market] === true;
      converted = false;
      conversionUnavailable = false;
      const fragment = document.createDocumentFragment();
      let total = 0;
      const profiles = new Set(data.groups.map(g => g.profile));
      for (const group of data.groups) {
        const carriers = new Map();
        for (const zone of group.zones) {
          const regions = zone.countries.flatMap(c => (c.provinces || []).map(p => p.name));
          for (const rate of zone.rates) {
            const name = carrier(rate.name);
            if (!carriers.has(name)) carriers.set(name, []);
            carriers.get(name).push({ rate, regions });
          }
        }
        if (!carriers.size) continue;
        if (profiles.size > 1) fragment.append(element('h4', '', group.profile));
        const faq = element('div', 'bh-faq');
        for (const [name, rows] of carriers) {
          const details = element('details');
          const summary = element('summary');
          summary.append(element('span', '', translate(name)));
          const paid = rows.filter(r => r.rate.price && Number(r.rate.price.amount) > 0).map(r => r.rate.price);
          const currencies = new Set(paid.map(p => p.currencyCode));
          if (paid.length && currencies.size === 1) summary.append(element('span', 'bh-shipping__summary-price', t.from + money(paid.reduce((a, b) => Number(a.amount) < Number(b.amount) ? a : b), true)));
          else if (rows.every(r => r.rate.price && Number(r.rate.price.amount) === 0)) summary.append(element('span', 'bh-shipping__summary-price', t.free));
          const answer = element('div', 'bh-faq__answer');
          rows.forEach(({ rate, regions }) => answer.append(rateRow(rate, regions)));
          details.append(summary, answer);
          faq.append(details);
          total += rows.length;
        }
        fragment.append(faq);
      }
      if (!total) fragment.append(element('p', '', t.empty));
      content.replaceChildren(fragment);
      const notes = {
        cs: 'Částky jsou orientačně přepočtené kurzem Shopify do vybrané měny. Konečnou cenu a splnění podmínek potvrdí objednávka.',
        de: 'Die Beträge werden mit dem Shopify-Wechselkurs in die gewählte Währung umgerechnet und dienen zur Orientierung. Endpreis und Bedingungen werden beim Checkout bestätigt.',
        en: 'Amounts are converted to the selected currency using the Shopify exchange rate and are indicative. Final prices and conditions are confirmed at checkout.'
      };
      root.querySelector('[data-shipping-note]').textContent = converted && !conversionUnavailable ? notes[language] || notes.cs : t.note;
      const date = new Date(data.updatedAt);
      root.querySelector('[data-shipping-updated]').textContent = Number.isNaN(date.getTime()) ? '' : t.updated + date.toLocaleString(locale);
    }
    async function load() {
      content.replaceChildren(element('p', '', t.loading));
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(root.dataset.endpoint);
        url.searchParams.set('country', root.dataset.country);
        const response = await fetch(url, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Unavailable');
        const data = await response.json();
        if (!data.ok || !Array.isArray(data.groups)) throw new Error('Invalid response');
        render(data);
      } catch {
        const button = element('button', 'bh-shipping__retry', t.retry);
        button.type = 'button';
        button.addEventListener('click', load);
        content.replaceChildren(element('p', '', t.error), button);
      } finally { clearTimeout(timer); }
    }
    load();
  }
  document.querySelectorAll('[data-bh-shipping]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bh-shipping]').forEach(initialize));
})();
